import React from 'react'
import { Link } from 'react-router-dom'

interface SmartCampaignBackButtonProps {
    href?: string
    onBack?: () => void
}

export const SmartCampaignBackButton = ({ href, onBack }: SmartCampaignBackButtonProps) => {
    const className =
        'group relative inline-flex items-center rounded-md border-0 bg-transparent py-1 pr-2 ' +
        'text-[14px] font-[500] text-[#8FA3B8] hover:text-black ' +
        'transition-colors duration-150 ease-out no-underline hover:no-underline'

    const inner = (
        <>
            <svg
                width="13"
                height="13"
                viewBox="0 0 15 15"
                fill="none"
                aria-hidden="true"
                className="absolute -left-[18px] -translate-y-px transition-transform duration-150 ease-out group-hover:-translate-x-px"
            >
                <path
                    d="M10 2.5L5 7.5l5 5"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            Back
        </>
    )

    if (href) {
        return (
            <Link to={href} className={className}>
                {inner}
            </Link>
        )
    }

    return (
        <button type="button" onClick={onBack} className={className}>
            {inner}
        </button>
    )
}
